module.exports = __webpack_public_path__ + "img/convective-outlook.c03512b8.png";